import {MSAL_ACCESS_TOKEN_KEY} from '@/shared/constants/globalConstants'

/**
 * Safely decodes the payload segment of a JWT (base64url encoded).
 * @param {string} token - The JWT to decode.
 * @returns {Object} The decoded claims, or an empty object on any failure.
 */
export const decodeJwtPayload = (token) => {
  if (typeof token !== 'string' || !token.includes('.')) return {}
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(json)
  } catch {
    return {}
  }
}

export const readUserFromClaims = (claims = {}, fallbackEmail = '') => {
  const firstName = claims.firstName || claims.given_name || ''
  const lastName = claims.lastName || claims.family_name || ''
  const email = claims.email || claims.preferred_username || fallbackEmail
  const userId = claims.oid || claims.sub || ''
  const displayName = [firstName, lastName].filter(Boolean).join(' ').trim() || claims.name || email || 'unknown'

  return {firstName, lastName, email, userId, displayName, claims}
}

/**
 * Resolves the signed-in user's identity from the MSAL id token stored by the
 * shell. The shell writes the id token to localStorage (`msalAccessToken`) and
 * it is shared across MFEs on the same origin.
 * @returns {{firstName: string, lastName: string, email: string, userId: string, displayName: string, claims: Object}}
 */
export const readUserFromStorage = () => {
  const claims = decodeJwtPayload(localStorage.getItem(MSAL_ACCESS_TOKEN_KEY))

  return readUserFromClaims(claims)
}
